<template>
  <div class="form-container">
    <h1 class="title">LET'S WORK TOGETHER</h1>
    <form @submit.prevent="sendEmail" class="contact-form">
      <div class="form-group">
        <label for="name">Name</label>
        <input v-model="form.name" type="text" id="name" required placeholder="Your Name" />
      </div>
      <div class="form-group">
        <label for="email">Email</label>
        <input v-model="form.email" type="email" id="email" required placeholder="Your@email.com" />
      </div>
      <div class="form-group">  
        <label for="budget">Budget</label>
        <select v-model="form.budget" id="budget" required>
          <option value="" disabled>Select...</option>
          <option>&lt;$3k</option>
          <option>$3k - $5k</option>
          <option>$5k - $10k</option>
          <option>>$10k</option>
        </select>
      </div>
      <div class="form-group">
        <label for="message">Message</label>
        <textarea v-model="form.message" id="message" required placeholder="Message"></textarea>
      </div>
      <button type="submit" class="submit-btn">Submit</button>
    </form>
  </div>
</template>

<script>
import emailjs from 'emailjs-com';

export default {
  data() {
    return {
      form: {
        name: '',
        email: '',
        budget: '',
        message: ''
      }
    };
  },
  methods: {
    sendEmail() {
      emailjs.send('service_pamxyy4', 'template_yg11hne', this.form, 'y3LTt-etrHp9cxK4b')
        .then((response) => { // eslint-disable-line no-unused-vars
          alert('Message sent successfully!');
          this.form = { name: '', email: '', budget: '', message: '' };
        })
        .catch((error) => {
          alert('Failed to send message. Please try again.');
          console.error(error);
        });
    }
  }
};
</script>

<style scoped>
.form-container {
  background: #1a1a1a;
  padding: 20px;
  color: #fff;
  font-family: Arial, sans-serif;
  border-radius: 10px;

}

.title {
  text-align: center;
  font-size: 2.5em;
  margin-bottom: 20px;
  text-transform: uppercase;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

label {
  margin-bottom: 5px;
  font-size: 0.9em;
}

input, select, textarea {
  padding: 10px;
  border: none;
  border-radius: 5px;
  background: #333;
  color: #fff;
  font-size: 1em;
}

select {
  appearance: none;
  background: #333 url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="%23fff"><polygon points="0,0 12,0 6,12"/></svg>') no-repeat right 10px center;
}

textarea {
  height: 100px;
  resize: vertical;
}

.submit-btn {
  padding: 10px;
  background: #f28c38;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 1em;
  cursor: pointer;
}

.submit-btn:hover {
  background: #e07b2d;
}
</style>